// This is the client side implementation of KF-Filter structure.
import { FieldClass } from "./fieldclass";
import { resolveRelativeValue } from "./utils";

function executeFilter(filter, data, metadata) {
  let criterias = getCriteria(filter);
  let finalResult = true;
  for (let cryOrCon of criterias) {
    let result;
    if (isCriteria(cryOrCon)) {
      result = executeFilter(cryOrCon, data, metadata);
    } else {
      result = executeCondition(cryOrCon, data, metadata);
    }
    if (!result && isAND(filter)) {
      return false;
    } else if (result && isOR(filter)) {
      return true;
    }
    finalResult = finalResult && result;
  }
  return finalResult;
}

function executeCondition(condition, data, metadata) {
  let fieldId = condition["LHSField"];
  let field = metadata[getField(fieldId)];
  let fieldClass = FieldClass[field.Type];

  let LHS = data[getField(fieldId)];

  //for lookup and currency
  if (condition["LHSAttribute"]) {
    if (field.Type === "Reference") {
      LHS = LHS[condition["LHSAttribute"]];
      for (let f of field.Attributes) {
        if (f.Id === condition["LHSAttribute"]) {
          fieldClass = FieldClass[f.Type];
          break;
        }
      }
    }
    if (field.Type === "Currency") {
      if (condition["LHSAttribute"] === "Value")
        fieldClass = FieldClass.CurrencyValue;
      else if (condition["LHSAttribute"] === "Unit")
        fieldClass = FieldClass.CurrencyUnit;
    }
  }

  let RHS = condition["RHSValue"];
  if (condition["RHSType"] === "Field") {
    RHS =
      data[condition["RHSField"]] ||
      resolveRelativeValue(condition["RHSField"], field.Type, data);
  }

  return fieldClass[condition.Operator](LHS, RHS, data);
}

export function getCriteria(filter) {
  return filter["OR"] || filter["AND"];
}

export function isAND(criteria) {
  return Boolean(criteria["AND"]);
}

export function isOR(criteria) {
  return Boolean(criteria["OR"]);
}

export function isCriteria(cryOrCon) {
  return isOR(cryOrCon) || isAND(cryOrCon);
}

function getField(fieldId) {
  if (fieldId.indexOf(".") !== -1) {
    return fieldId.split(".")[1];
  }
  return fieldId;
}

// const filterObject = {
//   AND: [
//     {
//       AND: [
//         {
//           LHSField: "Title",
//           Operator: "NOT_EQUAL_TO",
//           RHSType: "Value",
//           RHSValue: "sarav",
//           RHSField: null,
//           LHSAttribute: null,
//           RHSAttribute: null
//         }
//       ]
//     }
//   ]
// };

// const metadata = {
//   Title: {
//     _id: "Title",
//     Name: "Title",
//     Type: "Text"
//   },
//   _item_id: "ABC-1"
// };

// const data = {
//   Title: "sara",
//   _item_id: "ABC-1"
// };

export function applyFilter(filterObject, data, metadata) {
  if (!filterObject || (filterObject && Object.keys(filterObject).length === 0))
    return true;
  return executeFilter(filterObject, data, metadata);
}
